import { createFlickity } from './flickity';

export function init() {
	Array.from(document.querySelectorAll('.js-hz-menu'))
		.forEach(element => HorizontalMenu(element));
}

export function HorizontalMenu(element) {
	if (!element) {
		return;
	}

	createFlickity(element, {
		cellAlign: 'left',
		contain: true,
		freeScroll: true,
		lazyLoad: true,
		pageDots: false,
	});
}
